import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGuideQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  loggedUserId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isAnon?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetGuideQuery = { __typename?: 'query_root', guides_by_pk?: { __typename?: 'guides', id: any, title?: string | null, description?: string | null, status: string, video_url?: string | null, guide_file_url?: string | null, organization_id?: any | null, created_at: any, updated_at: any, partition_id?: string | null, doctrine_doc_id?: string | null, created_by_user_id?: string | null, handover_id?: any | null, author?: { __typename?: 'users', first_name: string, last_name: string } | null, guide_steps: Array<{ __typename?: 'guide_steps', id: any, step_number: number, title: string, body?: string | null, image_url?: string | null, video_url?: string | null, start_time?: any | null, end_time?: any | null }>, product_guides: Array<{ __typename?: 'product_guides', id: any, product?: { __typename?: 'products', id: any, name: string, photo_link?: string | null, installed_products?: Array<{ __typename?: 'installed_products', id: any, property?: { __typename?: 'properties', id: any, name: string } | null }> } | null }>, guide_feedbacks?: Array<{ __typename?: 'guide_feedbacks', id: any, helpful: boolean, notes?: string | null, created_by_user_id: string, created_at: any, guide_id: any }> } | null };


export const GetGuideDocument = gql`
    query getGuide($id: uuid!, $loggedUserId: String = "", $isAnon: Boolean = false) {
  guides_by_pk(id: $id) {
    id
    title
    description
    status
    video_url
    guide_file_url
    organization_id
    created_at
    updated_at
    partition_id
    doctrine_doc_id
    created_by_user_id
    author {
      first_name
      last_name
    }
    handover_id
    guide_steps(order_by: {step_number: asc}) {
      id
      step_number
      title
      body
      image_url
      video_url
      start_time
      end_time
    }
    product_guides {
      id
      product {
        id
        name
        photo_link
        installed_products(distinct_on: property_id) @skip(if: $isAnon) {
          id
          property {
            id
            name
          }
        }
      }
    }
    guide_feedbacks(where: {created_by_user_id: {_eq: $loggedUserId}}) @skip(if: $isAnon) {
      id
      helpful
      notes
      created_by_user_id
      created_at
      guide_id
    }
  }
}
    `;

/**
 * __useGetGuideQuery__
 *
 * To run a query within a React component, call `useGetGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuideQuery({
 *   variables: {
 *      id: // value for 'id'
 *      loggedUserId: // value for 'loggedUserId'
 *      isAnon: // value for 'isAnon'
 *   },
 * });
 */
export function useGetGuideQuery(baseOptions: Apollo.QueryHookOptions<GetGuideQuery, GetGuideQueryVariables> & ({ variables: GetGuideQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuideQuery, GetGuideQueryVariables>(GetGuideDocument, options);
      }
export function useGetGuideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuideQuery, GetGuideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuideQuery, GetGuideQueryVariables>(GetGuideDocument, options);
        }
export function useGetGuideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuideQuery, GetGuideQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuideQuery, GetGuideQueryVariables>(GetGuideDocument, options);
        }
export type GetGuideQueryHookResult = ReturnType<typeof useGetGuideQuery>;
export type GetGuideLazyQueryHookResult = ReturnType<typeof useGetGuideLazyQuery>;
export type GetGuideSuspenseQueryHookResult = ReturnType<typeof useGetGuideSuspenseQuery>;
export type GetGuideQueryResult = Apollo.QueryResult<GetGuideQuery, GetGuideQueryVariables>;